export default "__VITE_ASSET__Cqek8x3Z__"